import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "scrollable-item-list" }
const _hoisted_3 = ["id", "onClick"]

import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import { OperatorType } from '@/features/contacts/models/operatorTypes';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'JoinOperatorPicker',
  props: {
  value: {
    type: String as PropType<OperatorType>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: 'false',
  },
},
  emits: ["updated-hover-state", "updated-operator"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hovered = ref(false);
const selectedOperator = ref(OperatorType.And);
const active = ref(false);

watch(
  () => props.value,
  () => (selectedOperator.value = props.value),
  { immediate: true },
);

function getJoinOperators(): OperatorType[] {
  return [OperatorType.And, OperatorType.Or];
}

function selectOperator(type: OperatorType) {
  if (props.disabled) {
    return;
  }

  if (selectedOperator.value !== type) {
    emit('updated-operator', type);
  }
  selectedOperator.value = type;
  active.value = false;
}

function setActive(isOpen: boolean) {
  if (props.disabled) {
    return;
  }

  active.value = isOpen;
}

function onUpdatedHoverState(hover: boolean) {
  emit('updated-hover-state', hover);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DropDownMenu, {
      "drop-down-icon": "none",
      class: "operator-type-dropdown",
      disabled: __props.disabled,
      onOpen: setActive
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["button operator-type-button", { 'dropdown-active': active.value }]),
          disabled: __props.disabled,
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (onUpdatedHoverState(true))),
          onMouseout: _cache[1] || (_cache[1] = ($event: any) => (onUpdatedHoverState(false)))
        }, [
          _createElementVNode("span", null, _toDisplayString(selectedOperator.value), 1)
        ], 42, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getJoinOperators(), (operatorType) => {
            return (_openBlock(), _createElementBlock("a", {
              id: 'operator-type-item-' + operatorType,
              class: "dropdown-item",
              key: operatorType,
              onClick: ($event: any) => (selectOperator(operatorType))
            }, _toDisplayString(operatorType), 9, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})